import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular/src/interfaces';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { PayrollsService } from 'app/pages/payrolls/payrolls.service';
import { _downloadFile } from 'app/utils/trip2-query-builder/utils/helpers';
import { Subscription } from 'rxjs/Subscription';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { constant } from 'app/app.constants';

@Component({
  selector: 'app-eop-button',
  templateUrl: './eop-button.component.html',
  styleUrls: ['./eop-button.component.scss'],
})
export class EOPButtonComponent implements ICellRendererAngularComp, OnDestroy {
  public params: any;
  public suscriptions: Subscription[] = [];

  constructor(
    private loading: T2LoadingService,
    private service: PayrollsService,
    private _sweetAlertHelper: SweetAlertHelper
  ) {}

  agInit(params: any): void {
    this.params = params;
  }

  public invokeParentMethod() {
    if (!this.params.data.providerclaimtripid) {
      this._sweetAlertHelper.captureException(
        'This trip has no claim, so no EOB is available'
      );
      return;
    }
    this.loading.show('Downloading EOB...');
    this.suscriptions.push(
      this.service
        .createEobPdf(this.params.data.providerclaimtripid)
        .finally(() => {
          this.loading.hiden();
        })
        .subscribe({
          next: (data) => {
            _downloadFile(data.blob(), 'eob-' + this.params.data.providerclaimtripid + '.pdf');
          },
          error: (error) => {
            if (error.status === 404) {
              this._sweetAlertHelper.createCustomAlert({
                title: 'EOB Report',
                type: 'info',
                text: constant.MESSAGE_EOB_NOT_AVAILABLE
              });
              return;
            }
            this._sweetAlertHelper.captureException(error);
          },
        })
    );
  }

  refresh(): boolean {
    return false;
  }

  ngOnDestroy(): void {
    this.suscriptions.forEach((sub) => sub.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/grid-components/eop-button/eop-button.component.ts